import { Alert, Button, HStack } from '@chakra-ui/react'
import { Link } from 'react-router'
import { SectionHeading } from './Section/SectionHeading'
import { BadgeStep } from './ui/BadgeStep'


export const OfferInvalidMessage = ({ url }: { url: string }) => {
  return <Alert colorScheme='orange'
    gap={2} px={8} py={4}
    justifyContent='space-between'
  >
    <HStack gap={8}>
      <BadgeStep bg='orange.600'>!</BadgeStep>
      <SectionHeading sx={{ color: 'orange.900', lineHeight: 1.6, fontWeight: 'semibold' }}>
        Vybraná nabídka již není platná. <br /> 
        Prosím vraťte se zpět na srovnání nabídek pro přepočítání.
      </SectionHeading>
    </HStack>
    <Button
      ml={8}
      as={Link}
      to={url}
      colorScheme='orange'
    >
      Zpět
    </Button>
  </Alert>
}